<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <page-header title="Lista" subTitle="Usuários">
      <router-link
        class="float-right text-white btn btn-success"
        :to="{ name: 'admin-user-new' }"
      >
        Novo usuário
      </router-link>
    </page-header>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div
            class="card-header border-bottom d-md-flex justify-content-around"
          >
            <div
              class="col-md-6 col-12 d-flex justify-content-center justify-content-md-start align-items-center"
            >
              <h6 class="m-md-0 m-2">Usuários Ativos</h6>
            </div>
            <div class="col-md-6 col-12">
              <input-search
                :model.sync="pagination.search"
                id="input_user_list_search"
              />
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <user-table :users="users.list" />
            </div>
            <pagination
              :total-items="users.total_items"
              :pagination.sync="pagination"
              eventName="update:pagination_user_list"
            />
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';

import Events from '_utils/events';
import PageHeader from '_shared/PageHeader.vue';
import Pagination from '_shared/Pagination.vue';
import InputSearch from '_shared/InputSearch.vue';
import paginationStorageMixin from '_common/mixins/paginationStorageMixin';
import UserTable from '../components/UserListTable.vue';

export default {
  name: 'user-list',
  components: {
    PageHeader,
    Pagination,
    UserTable,
    InputSearch,
  },
  mixins: [paginationStorageMixin],
  data() {
    return {
      pagination: {
        search: '',
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    users() {
      const { userList } = this.$store.state.user;
      if (userList && userList.list.length) {
        return userList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions(['setToggle', 'getUserList']),
    getList() {
      this.getUserList(this.pagination);
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination_user_list', pagination => {
      const paramsPage = parseInt(this.$route.params.page, 10);
      this.saveCurrentPage(this.pagination);
      if (paramsPage !== pagination.page) {
        this.$router.push({ params: { page: pagination.page } });
      }
      this.getList();
    });
  },
  destroyed() {
    Events.$off('update:pagination_user_list');
  },
};
</script>
